module.exports = __webpack_public_path__ + "204f0738d4f88941fa2cdef2c68511ed.png";